import { render, staticRenderFns } from "./DevolucaoList.vue?vue&type=template&id=55af3482&scoped=true"
import script from "./DevolucaoList.vue?vue&type=script&lang=js"
export * from "./DevolucaoList.vue?vue&type=script&lang=js"
import style0 from "./DevolucaoList.vue?vue&type=style&index=0&id=55af3482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af3482",
  null
  
)

export default component.exports